export default "__VITE_ASSET__DsaiTVxK__"